// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body #fc_frame.fc-widget-normal{display:none;position:absolute}body.lan_en_body>#fc_frame.fc-widget-normal{display:block;position:absolute}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
